import React, { useState } from "react";
import { Modal } from "../../components/admin/Modal";
import { CategoryForm } from "../../components/admin/CategoryForm";
import { API_BASE_URL } from "../../API/endpoint";

export const CategoriesTab = ({ categories, onSave, onDelete }) => {
  const [editingCategory, setEditingCategory] = useState(null);

  const handleSave = async (categoryData) => {
    const id = categoryData.get ? categoryData.get("id") : editingCategory?.id;
    await onSave(id, categoryData);
    setEditingCategory(null);
  };

  return (
    <div className="admin-section admin-categorie-tab">
      <div className="admin-header">
        <h2>Gestion des Catégories</h2>
        <button className="btn-add" onClick={() => setEditingCategory({})}>
          + Ajouter une catégorie
        </button>
      </div>

      <Modal
        isOpen={!!editingCategory}
        onClose={() => setEditingCategory(null)}
        title={
          editingCategory?.id
            ? "Modifier la catégorie"
            : "Nouvelle catégorie"
        }
      >
        <CategoryForm
          category={editingCategory || {}}
          onSave={handleSave}
          onCancel={() => setEditingCategory(null)}
        />
      </Modal>

      <div className="table-container">
        <div className="product-admin-table">
          <div className="product-header">
            <div>Image</div>
            <div>Nom</div>
            <div>Actions</div>
          </div>
          {categories.map((category) => (
            <div className="product-row" key={category.id}>
              <div className="product-cell">
                {category.path && (
                  <img
                    src={`${API_BASE_URL}${category.path}?t=${Date.now()}`}
                    alt={category.name}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
              <div className="product-cell">{category.name}</div>
              <div className="product-cell admin-actions">
                <button
                  className="btn-edit"
                  onClick={() => setEditingCategory(category)}
                >
                  <i className="bi bi-pencil"></i>
                </button>
                <button
                  className="btn-delete"
                  onClick={() => onDelete(category.id)}
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
